// Emblema geométrico de red logística: nodos, ruta y monograma ET.
export const LogoEmblem = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 128 128"
    role="img"
    aria-label="Empresas de Transporte Albacete"
  >
    <defs>
      <linearGradient id="etLogoBg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#2457f5" />
        <stop offset="1" stopColor="#6d5dfc" />
      </linearGradient>
    </defs>
    <rect x="6" y="6" width="116" height="116" rx="32" fill="url(#etLogoBg)" />
    <rect
      x="14.5"
      y="14.5"
      width="99"
      height="99"
      rx="24.5"
      fill="none"
      stroke="#cbd8ff"
      strokeOpacity="0.16"
      strokeWidth="1.5"
    />
    {/* E */}
    <g fill="#ffffff">
      <rect x="34" y="40" width="10" height="50" rx="2" />
      <rect x="34" y="40" width="22" height="10" rx="2" />
      <rect x="34" y="60" width="18" height="10" rx="2" />
      <rect x="34" y="80" width="22" height="10" rx="2" />
    </g>
    {/* T: barra + carretera */}
    <rect x="52" y="40" width="44" height="10" rx="2" fill="#ffffff" />
    <polygon points="68.5,50 79.5,50 82.5,90 65.5,90" fill="#ffffff" />
    <g fill="#07112d">
      <rect x="72.5" y="56" width="3" height="7" rx="1.5" />
      <rect x="72.3" y="68" width="3.4" height="8" rx="1.7" />
      <rect x="72" y="81" width="4" height="7" rx="2" />
    </g>
  </svg>
);

const Logo = () => (
  <>
    <LogoEmblem className="brand__mark" />
    <span className="brand__divider" aria-hidden="true" />
    <span className="brand__wm">
      <span className="brand__pre">Empresas de</span>
      <span className="brand__name">Transporte</span>
      <span className="brand__city">Albacete</span>
    </span>
  </>
);

export default Logo;
